import React from 'react';

const offers =(props)=>{
    return(
        <div className="offers">
            
           <div className="offers-text">
                <h2 className="offers-title offers-cursive">Exclusive offer</h2>
                <h2 className="offers-title">Summer Starter Pack <br></br> $649</h2>
                
                <h4 className="offers-subtitle">Valid until {props.expDate}</h4>
                {/**<h4 className="offers-subtitle">Use coupon "{props.coupon}" at checkout</h4>*/}
                <h4 className="offers-subtitle"><a style={{color:"#1da1f2"}} href="callto:+17868017389">Call us to reedem</a></h4>
                
                <h3 className="offers-endStatement">Website design, logo and business cards design, 50$ for Facebook ads or $50 off Paper Stock, basic SEO, 1st Year of Maintenace included, <br></br>Google Analytics, Heatmap and user recording analytics, Business e-mails, Full Ownership, Full Deployment, Source Files and design files. </h3>
            </div>
            {/*<a className={"button"} onClick={props.link}>Explore Offers</a>*/}

                {/*<div className="offers-overlay"></div>*
                
    <a className={"button"} onClick={props.link}> </a>*/}
                <div className="offers-background"></div>
        </div>
    );
}

export default offers;